import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { TaskStatus } from 'fabscale-app/models/enums/task-status';
import { DateRangeOptional } from 'fabscale-app/models/date-range';
import { MaintenanceTask } from 'fabscale-app/models/maintenance-task';
import { MaintenanceTaskQueryOptions } from 'fabscale-app/services/store/maintenance-task';
import UserSessionService from 'fabscale-app/services/user-session';
import { DateTime } from 'luxon';

interface Args {
  assignedUserId?: string;
}

export default class DashboardWidgetsOpenTasks extends Component<Args> {
  @service userSession: UserSessionService;

  get query(): MaintenanceTaskQueryOptions {
    let { assignedUserId } = this.args;

    let date = DateTime.local().startOf('day');

    return {
      status: 'OPEN',
      assignedUserIds: assignedUserId ? [assignedUserId] : undefined,

      dateRange: new DateRangeOptional({
        start: undefined,
        end: date.startOf('day'),
      }),
    };
  }

  @action
  onToggleStatus(
    tasks: MaintenanceTask[],
    {
      id,
      status,
      completionDate,
    }: {
      id: string;
      status: TaskStatus;
      completionDate?: DateTime;
    }
  ) {
    let task = tasks.find((task) => task.id === id);

    if (task) {
      task.status = status;
      task.completionDate = completionDate;
    }
  }
}
